import { Observable } from "rxjs/Observable";
import * as actions from "./report-layout.actions";
import { ReportLayout } from "./report-layout.model";
import { RestrictedAccountObjectStoreFacade } from "../restricted-account-object/restricted-account-object.store-facade";
import { ActionOptionsArgs } from "../../../core/store/actions/base-actions";
import { Qry } from "../query-facade";

export class ReportLayoutStoreFacade extends RestrictedAccountObjectStoreFacade<ReportLayout> {

    getAll(): Observable<Array<ReportLayout>> {
        return this.select(Qry.getInstance().reportLayout.byActiveAccount);
    }

    create(reportLayout: ReportLayout): void {
        this.dispatch(new actions.SubmitAction(reportLayout));
    }

    update(reportLayout: ReportLayout): void {
        this.dispatch(new actions.SubmitAction(reportLayout));
    }

    insert(reportLayout: ReportLayout): void {
        this.dispatch(new actions.SubmitAction(reportLayout, {persistable: true, restful: false}));
    }

    remove(reportLayout: ReportLayout, options?: ActionOptionsArgs): void {
        this.dispatch(new actions.RemoveAction(reportLayout, options));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/report-layout/report-layout.store-facade.ts